module.exports = __webpack_public_path__ + "static/media/point5.bbc63d39.png";